import { SxProps } from '@mui/material';
import { black1, grey10, grey9 } from 'app/components/ThemeProvider/colors';

export const confirmBox: SxProps = {
  background: 'white',
  borderRadius: '8px',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  p: '48px',
};

export const detailsBox: SxProps = { display: 'flex', rowGap: '28px', flexWrap: 'wrap', columnGap: '83px' };

export const details: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '363px',
  // '&:nth-of-type(2n)': {
  //   width: 'calc(100% - 530px)',
  // },
};

export const additionsBox: SxProps = { mt: '28px', display: 'flex', flexDirection: 'column', gap: '12px' };

export const detailsInfoDesc: SxProps = { fontSize: '17px', color: 'rgba(20, 25, 31, 0.60)', lineHeight: '1' };

export const detailsInfo: SxProps = { fontSize: '20px', color: black1, lineHeight: '1', fontWeight: '600' };

export const fileBox: SxProps = {
  width: '75%',
  background: grey10,
  borderRadius: '8px',
  display: 'flex',
  p: '12px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const watchBtn = {
  background: '#EAEAEA',
  height: '36px',
  padding: '8px 16px',
  borderRadius: '6px',
  color: black1,
  textDecoration: 'none',
  lineHeight: 1,
  fontWeight: 600,
  fontFamily: 'Yelo',
};
